import { store } from '../store'

// A server answer while the app went offline by itself (connection errors, not the user's choice) means
// the connection is back: the OfflineIndicator checks at once instead of at its next interval, so the
// "offline" bar does not stay up while answers are already being saved again.
export const SERVER_REACHABLE_EVENT = 'alphaprocess:server-reachable'

export function notifyServerReachable() {
  const { isOffline, offlineManual } = store.getState().core
  if (isOffline && !offlineManual) window.dispatchEvent(new Event(SERVER_REACHABLE_EVENT))
}
